export default class PvApiForbiddenException extends Error {
    constructor() {
        super();
        this.name = '403 forbidden';
        this.message = 'Нет доступа';
    }
}